import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WhatsAppIcon = ({ size = 28 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="currentColor">
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.4-.545-.489-1.09-1.084-1.49-1.701-.073-.11-.158-.27-.158-.404 0-.32.946-.84.946-1.31 0-.225-.652-2.193-.872-2.402-.225-.221-.523-.245-.822-.245-.187 0-.36.034-.524.04-.299 0-.598.055-.83.276-.327.305-.974 1.044-.974 2.387 0 1.376.926 2.726 1.652 3.659.31.398.633.81 1 1.18.75.762 1.59 1.428 2.532 1.951.642.355 1.346.722 2.06.886.357.082.713.137 1.067.137.81 0 1.49-.225 1.95-.776.235-.286.487-.84.487-1.235 0-.183-.046-.366-.16-.5-.232-.273-.984-.567-1.305-.717l-.563-.224z M16.005 0a16 16 0 0 0-13.7 24.232L.07 32l7.91-2.214A16 16 0 1 0 16.005 0zm0 29.184a13.18 13.18 0 0 1-6.708-1.83l-.481-.286-4.99 1.397 1.421-4.866-.314-.5a13.18 13.18 0 1 1 11.072 6.085z"/>
  </svg>
);

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Show button after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip for 5 seconds
      setTimeout(() => {
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 5000);
      }, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '5493411551234'; // Formato internacional sin espacios
    const message = encodeURIComponent(
      '¡Hola! Me gustaría consultar sobre Obrador Pomodoro 🍝'
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 z-40 flex items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-white px-4 py-3 rounded-xl shadow-2xl border border-gray-200 animate-slide-in-left max-w-xs">
          <p className="text-sm font-medium text-gray-900">
            ¿Tenés alguna consulta?
          </p>
          <p className="text-xs text-gray-600 mt-1">
            ¡Escribinos por WhatsApp! 💬
          </p>
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            <X size={14} />
          </button>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="group relative bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce-slow"
        aria-label="Contactar por WhatsApp"
      >
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></span>
        
        {/* Icon */}
        <span className="relative z-10 block">
          <WhatsAppIcon size={28} />
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;
